// Migrated
// Translated
<template>
  <div
    v-if="activeItinerary && filteredActiveItinerary?.length"
    class="product-featured-itinerary"
  >
    <div class="mt-4 md:mt-4">
      <LazyInfoSection
        v-if="itineraries && itineraries.length > 1"
        class="print-hidden print-no-overlap -mt-12 mb-12 !bg-dirty-blue"
        :title="$t('multipleItineraryTitle')"
        title-key="multipleItineraryTitle"
        :text="$t('multipleItineraryDescription')"
        text-key="multipleItineraryDescription"
        :background-color="colors.secondary"
      >
        <template #icon>
          <fa
            icon="calendar"
            class="size-full text-primary"
          />
        </template>
        <div class="mt-2 -mb-2">
          <button
            v-for="(itinerary, index) in itineraries"
            :key="index"
            class="mr-2 rounded-4xl px-4 py-2 mb-2 font-secondary text-base w-full md:w-auto"
            :value="index"
            name="activeItineraryIndex"
            :data-translation="itinerary?.name_translationkey"
            :class="index === activeItineraryIndex
              ? 'bg-blue-800 text-white'
              : 'bg-white border-solid border border-primary md:border-zinc-300 hover:bg-blue-800/75 hover:text-white'"
            @click="$emit('selectItinerary', $event.target.value)"
          >
            {{ itinerary.name }}
          </button>
        </div>
      </LazyInfoSection>
    </div>

    <div
      v-for="(itinerary, index) in filteredActiveItinerary"
      :key="itinerary.id"
      class="w-full mt-4 md:mt-4 mt-print-0 p-0 print-no-overlap"
    >
      <LazyItineraryBox
        v-if="itinerary.day === 'x'"
        :box-type="itinerary.box_type"
        :itinerary-day="itinerary"
        :is-destination="isDestination"
      >
        <div
          :data-translation="itinerary?.htmltext_translationkey"
          v-html="itinerary.htmltext"
        />
      </LazyItineraryBox>
      <LazyItineraryDay
        v-else
        :is-destination="isDestination"
        :active-marker="activeMarker"
        :itinerary-day="itinerary"
        :start-icon="getItineraryDayStartIcon(index)"
        @set-marker="$emit('setMarker', itinerary.day)"
        @open-map="$emit('openMap', itinerary.day)"
      />
    </div>
  </div>
</template>

<script setup>
import colors from '#tailwind-config/theme/colors'

const props = defineProps({
  activeItinerary: {
    type: Object,
    default: () => ({ itinerary: [] }),
  },

  itineraries: {
    type: Array,
    required: true,
  },

  activeItineraryIndex: {
    type: Number,
    required: true,
  },

  activeMarker: {
    type: String,
    default: null,
  },

  isDestination: {
    type: Boolean,
    default: false,
  },
})

defineEmits([
  'setMarker',
  'openMap',
  'selectItinerary',
])

const lastDayItineraryIndex = computed(() =>
  (props.activeItinerary?.itinerary?.length - 1)
  -
  [...props.activeItinerary?.itinerary || []]
    .reverse()
    .findIndex((itinerary) => itinerary.box_type === 'day')
)

const filteredActiveItinerary = computed(() =>
  props.activeItinerary?.itinerary?.filter(itinerary => !!(
    itinerary.title ||
    itinerary.htmltext ||
    itinerary.map_points?.length ||
    itinerary.media?.length
  ))
)

const getItineraryDayStartIcon = (dayIndex) => {
  return [0, lastDayItineraryIndex.value].includes(dayIndex)
    ? 'map-marker'
    : 'circle'
}
</script>
